import { App } from './app/app';
import { LicenseManager } from 'ag-grid-enterprise';
import { appConfig } from './app/app.config';
import { bootstrapApplication } from '@angular/platform-browser';
import { environment } from './environments/environment';

LicenseManager.setLicenseKey(environment.agGridLicenseKey);
bootstrapApplication(App, appConfig).catch((err) => console.error(err));
